<template>
    <div class='main'>
      <img id='main_background' :src='topBackground'>
      <div id='main_body'>
        <div id='title_bar'>
          <div id='websiteName'>扫描大师转换器</div>
          <div id='navigation'>
            <div @click='other2PdfClick' :class='{navigation_item:true,navigation_item_nomal:cssStyle.title_bar_check!=1,navigation_item_check:cssStyle.title_bar_check==1,navigation_item_check_bottom:cssStyle.title_bar_check==1}'>文档转PDF</div>
            <div @mouseover='pdf2OtherMoveOn=true' @mouseout='pdf2OtherMoveOn=false' :class='{navigation_item:true,navigation_item_nomal:!pdf2OtherIsClick,navigation_item_check:pdf2OtherIsClick,navigation_item_check_bottom:pdf2OtherIsClick}'>
              PDF转文档
              <div class="zq-drop-list" v-show="pdf2OtherMoveOn" @mouseover='pdf2OtherSelectMove($event)'>
                <div @click='selectClick(2)' :class='{convert_type:true,use_bottom_border:true,convert_type_move_on:1==selectMove}' data-radius='1'>PDF转Word</div>
                <div @click='selectClick(3)' :class='{convert_type:true,use_bottom_border:true,convert_type_move_on:2==selectMove}' data-radius='2'>PDF转PPT</div>
                <div @click='selectClick(4)' :class='{convert_type:true,use_bottom_border:true,convert_type_move_on:3==selectMove}' data-radius='3'>PDF转Excel</div>
                <div @click='selectClick(5)' :class='{convert_type:true,convert_type_move_on:4==selectMove}' data-radius='4'>PDF转图片</div>
              </div>
            </div>
            <div @click='login' v-show="!userBarShow" :class='{userbar:true,navigation_item:true,navigation_item_nomal:!loginClick,navigation_item_check:loginClick,navigation_item_check_bottom:loginClick}'>登录 / 注册</div>
            <div v-show="userBarShow" :class='{userbar:true,navigation_item:true}'>
                欢迎：{{nickname}}
            </div>
            <div v-show="userBarShow" :class='{logout:true}' @mouseover='logoutMoveOn=true' @mouseout='logoutMoveOn=false' @click='logout'>
              <div :class='{logout:true}'>[</div>
              <div :class='{logout:true,logout_move:logoutMoveOn}'>登出</div>
              <div :class='{logout:true}'>]</div>
            </div>
          </div>
        </div>
      </div>
      <loginPopup ref='loginPop' :dialogVisible="visible" @close="close" @login_success="login_success"></loginPopup>
      <div class='import_module'>
        <other2pdf v-if='cssStyle.title_bar_check === 1' @show="show" @msgShow="msgShow"></other2pdf>
        <pdf2word v-if='cssStyle.title_bar_check === 2' @show="show" @msgShow="msgShow"></pdf2word>
        <pdf2ppt v-if='cssStyle.title_bar_check === 3' @show="show" @msgShow="msgShow"></pdf2ppt>
        <pdf2excel v-if='cssStyle.title_bar_check === 4' @show="show" @msgShow="msgShow"></pdf2excel>
        <pdf2img v-if='cssStyle.title_bar_check === 5' @show="show" @msgShow="msgShow"></pdf2img>
      </div>
      <msgPopup :msgShow="msgVisible" :msg="msgText" @msgClose="msgClose"></msgPopup>
    </div>
</template>

<script>
import { Message } from 'view-design'
import msgPopup from './popup/msgPopup'
import cookie from '../common/cookie'
import { loginApi } from '@/components/login/login'
import loginPopup from '../login/popup/loginPopup'
import other2pdf from '../convert/other2pdf'
import pdf2word from '../convert/pdf2word'
import pdf2ppt from '../convert/pdf2ppt'
import pdf2excel from '../convert/pdf2excel'
import pdf2img from '../convert/pdf2img'

export default {
  name: 'homePage',
  data () {
    return {
      cssStyle: {
        title_bar_check: 1
      },
      topBackground: require('../../assets/img/bg1_home.jpg'),

      phone: null,
      verify_code: null,
      showTime: true,
      sendTime: '',
      timer: null,
      nickname: null,
      loginShow: false,
      userBarShow: false,
      visible: false,
      msgVisible: false,
      msgTitle: '',
      msgText: '',
      selectMove: 0,
      loginClick: false,
      pdf2OtherMoveOn: false,
      pdf2OtherIsClick: false,
      logoutMoveOn: false
    }
  },
  components: {
    msgPopup,
    cookie,
    loginPopup,
    other2pdf,
    pdf2word,
    pdf2ppt,
    pdf2excel,
    pdf2img
  },
  methods: {
    login () {
      this.show()
    },
    login_success (nickname) {
      this.nickname = nickname
      this.userBarShow = true
    },
    logout_success () {
      this.userBarShow = false
    },
    pdf2OtherSelectMove (ev) {
      this.selectMove = ev.target.dataset.radius
    },
    other2PdfClick () {
      this.cssStyle.title_bar_check = 1
      this.pdf2OtherIsClick = false
    },
    selectClick (order) {
      this.cssStyle.title_bar_check = order
      this.pdf2OtherIsClick = true
    },
    show () {
      this.loginClick = true
      this.visible = true
      this.$refs.loginPop.qrcodeRefresh()
    },
    close () {
      this.loginClick = false
      this.visible = false
    },
    msgShow (msg) {
      this.msgText = msg
      this.msgVisible = true
    },
    msgClose () {
      this.msgVisible = false
    },
    async login_valid () {
      let msg = cookie.getUserMsg()
      if (msg !== null) {
        let result = await loginApi.validLogin()
        if (result.code === 0) {
          this.nickname = result.data.nickName
          this.userBarShow = true
        } else {
          this.nickname = null
          this.userBarShow = false
          this.show()
        }
      } else {
        this.show()
      }
    },
    async logout () {
      let result = await loginApi.logout()
      if (result.code === 0) {
        cookie.clearToken()
        this.nickname = ''
        this.userBarShow = false
        Message.info('登出成功')
      } else {
        this.msgShow(result.msg)
      }
    }
  },
  mounted () {
    this.login_valid()
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    min-width: 1263px;
  }
   #main_background {
    width:100%;
    height:580px;
    min-width: 1263px;
    top:0px;
    left:0px;
    margin: 0px;
    padding: 0px;
    position:absolute;
    z-index: -1;
  }
  #main_body {
    height:100px;
    width:100%;
    min-width: 1263px;
    z-index: 1;
  }
  #title_bar {
    width:100%;
    min-width: 1263px;
    display: inline-block;
    position: relative;
    top:50%;
    transform:translateY(-50%);
  }
  #websiteName {
    display: inline-block;
    font-family: PingfangScBold;
    width: 204px;
    font-size: 18px;
    color: #fc5e4c;
    letter-spacing: 1px;
    margin-left: 70px;
  }
  #navigation {
    display: inline;
    width: auto;
    height: 25px;
    min-width: 900px;
    text-align: right;
    vertical-align: top;
    float: right;
    margin-right: 70px;
  }
  .userbar {
    min-width: 90px;
    max-width:140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align:top;
    font-size: 14px;
    font-weight: 500;
    font-family: PingfangScBold;
    color: #e85141;
    line-height: 30px;
    letter-spacing: 1px;
  }
  .logout {
    width: auto;
    margin: 0px;
    padding: 0px;
    vertical-align:top;
    font-size: 14px;
    font-weight: 500;
    font-family: PingfangScBold;
    color: #e85141;
    line-height: 30px;
    letter-spacing: 1px;
    cursor: pointer;
    display: inline-block;
  }
  .logout_move {
    width: auto;
    margin: 0px;
    padding: 0px;
    vertical-align:top;
    font-size: 14px;
    font-weight: 500;
    font-family: PingfangScBold;
    color: #f7b502;
    line-height: 30px;
    letter-spacing: 1px;
    cursor: pointer;
    display: inline-block;
  }
  .navigation_item {
    display: inline-block;
    margin-left: 50px;
    cursor: pointer;
  }
  .navigation_item_check {
    width: auto;
    font-size: 14px;
    font-weight: 500;
    font-family: PingfangScBold;
    color: #e85141;
    line-height: 30px;
    letter-spacing: 1px;
  }
  .navigation_item_check_bottom{
    border-bottom: 2px solid #e85141;
  }
  .navigation_item_nomal {
    width: auto;
    opacity: .8;
    font-size: 14px;
    font-family: PingfangScBold;
    font-weight: 500;
    color: #46495f;
    line-height: 30px;
    letter-spacing: 1px;
  }
  .import_module {
    width: 100%;
    height: 450px;
    min-width: 1263px;
  }
  .zq-drop-list{
    width: 160px;
    min-width: 160px;
    position: absolute;
    float:left;
    background-color: #fcedec;
    box-shadow: 0px 2px 15px 0px #ffe3e0;
    border: 2px solid #f7b8b1;
    border-radius:8px;
    margin-left: -10px;
    margin-top: 2px;
  }
  .convert_type {
    text-align: center;
    line-height: 50px;
  }
  .use_bottom_border {
    border-bottom: 1px solid #f7b8b1;
  }
  .convert_type_move_on {
    background-color: #f8c0bc;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/homePage.vue